import React from "react";
import { Link, useParams, Navigate } from "react-router-dom";
import { Check, ArrowLeft } from "lucide-react";
import Seo from "../components/Seo";
import SectionEyebrow from "../components/SectionEyebrow";
import RevealOnScroll from "../components/RevealOnScroll";
import Button from "../components/Button";
import BigCTA from "../components/BigCTA";
import { SERVICES } from "../data/content";

const ServizioDetail = () => {
  const { slug } = useParams();
  const idx = SERVICES.findIndex((s) => s.slug === slug);
  if (idx === -1) return <Navigate to="/servizi" replace />;
  const s = SERVICES[idx];
  const next = SERVICES[(idx + 1) % SERVICES.length];

  return (
    <>
      <Seo
        title={`${s.title} | OnSports`}
        description={s.body}
        path={`/servizi/${s.slug}`}
      />

      <section className="bg-dodgers text-galactico pt-40 pb-24 md:pt-52 md:pb-32 relative overflow-hidden" data-testid="servizio-hero">
        <div className="container-os relative">
          <RevealOnScroll>
            <Link to="/servizi" className="inline-flex items-center gap-2 text-galactico/70 hover:text-lime transition-colors font-condensed uppercase tracking-widest text-sm">
              <ArrowLeft size={16} /> Tutti i servizi
            </Link>
          </RevealOnScroll>
          <RevealOnScroll delay={0.06}>
            <SectionEyebrow num={s.num} className="mt-8">{s.title}</SectionEyebrow>
          </RevealOnScroll>
          <RevealOnScroll delay={0.12}>
            <h1 className="display-h1 mt-7 max-w-[20ch]">{s.headline}</h1>
          </RevealOnScroll>
          <RevealOnScroll delay={0.2}>
            <p className="mt-8 body-lg opacity-85 max-w-[64ch]">{s.body}</p>
          </RevealOnScroll>
        </div>
      </section>

      <section className="section-pad bg-galactico text-dodgers" data-testid="servizio-inclusi">
        <div className="container-os">
          <div className="grid grid-cols-12 gap-8 md:gap-12">
            <div className="col-span-12 md:col-span-5">
              <RevealOnScroll>
                <SectionEyebrow>Cosa include</SectionEyebrow>
              </RevealOnScroll>
              <RevealOnScroll delay={0.1}>
                <h2 className="display-h2 mt-6">Ogni progetto, su misura.</h2>
              </RevealOnScroll>
              <RevealOnScroll delay={0.18}>
                <p className="mt-7 text-[1.0625rem] leading-relaxed max-w-[44ch]">
                  Nessun pacchetto preconfezionato: definiamo insieme il perimetro, gli
                  obiettivi e le metriche di successo prima di partire.
                </p>
              </RevealOnScroll>
            </div>
            <div className="col-span-12 md:col-span-7">
              <ul className="space-y-5">
                {s.items.map((it, i) => (
                  <RevealOnScroll key={i} delay={i * 0.05}>
                    <li className="flex items-start gap-5 border-b border-dodgers/15 pb-5">
                      <span className="flex-shrink-0 w-8 h-8 bg-lime text-dodgers flex items-center justify-center mt-1">
                        <Check size={16} strokeWidth={3} />
                      </span>
                      <span className="text-[1rem] md:text-[1.125rem] leading-relaxed">{it}</span>
                    </li>
                  </RevealOnScroll>
                ))}
              </ul>
              <div className="mt-10">
                <Link to="/contatti" data-testid="servizio-cta">
                  <Button variant="secondary-dark">{s.cta}</Button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section-pad bg-dodgers text-galactico" data-testid="servizio-next">
        <div className="container-os">
          <RevealOnScroll>
            <SectionEyebrow>Prossimo servizio</SectionEyebrow>
          </RevealOnScroll>
          <RevealOnScroll delay={0.1}>
            <Link
              to={`/servizi/${next.slug}`}
              className="group block mt-8 border-y border-galactico/20 py-10 md:py-14"
              data-hover="true"
            >
              <div className="grid grid-cols-12 gap-4 items-center">
                <span className="font-display col-span-2 md:col-span-1 text-4xl md:text-6xl text-lime leading-none">
                  {next.num}
                </span>
                <div className="col-span-10 md:col-span-9">
                  <h3 className="display-h2 group-hover:text-lime transition-colors">{next.title}</h3>
                </div>
                <span className="hidden md:flex col-span-2 justify-end font-condensed uppercase tracking-widest text-sm">
                  Vai al servizio →
                </span>
              </div>
            </Link>
          </RevealOnScroll>
        </div>
      </section>

      <BigCTA />
    </>
  );
};

export default ServizioDetail;
